import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-activeReturn",
  "use": "icon-activeReturn-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-activeReturn\">\n<g id=\"icon-activeReturn_Frame 427320028\">\n<g id=\"icon-activeReturn_31fanhui1\">\n<path id=\"icon-activeReturn_&#232;&#183;&#175;&#229;&#190;&#132;\" d=\"M8.32777 10.0004L14.7175 4.43417C15.0942 4.10553 15.0942 3.57367 14.7175 3.24608C14.3409 2.91797 13.7299 2.91797 13.3533 3.24608L6.28202 9.40647C5.90599 9.73458 5.90599 10.2667 6.28202 10.5938L13.3533 16.7539C13.5422 16.918 13.7891 17 14.036 17C14.2829 17 14.5298 16.918 14.7175 16.7534C15.0942 16.4253 15.0942 15.8942 14.7175 15.5661L8.32777 10.0004\" fill=\"#C7C7C7\" />\n</g>\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/activeReturn.svg
// module id = blH+
// module chunks = 103